import React from 'react';


const BTagsEditor = (props) => {
    return (
        <div>
            {props.children}

            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł:</label>
                <div className="col-sm-9">
                    <input type="text" name="title" className="form-control" defaultValue={props.settings?.title || "Powiązane linki:"} />
                </div>
            </div>
        </div>
    );
}


export default BTagsEditor;